// @ts-check

/**
 * Used for conversion tracking
 *
 * @param {ng.IWindowService} $window
 */
function getUrlParameters($window) {
  var pairs = $window.location.search.substring(1).split(/[&?]/);
  var res = {}, i, pair;
  for (i = 0; i < pairs.length; i++) {
      pair = pairs[i].split('=');
      if (pair[1])
          res[decodeURIComponent(pair[0])] = decodeURIComponent(pair[1]);
  }
  return res;
}

const CONVERSION_COOKIES_KEY = 'tcr';

export class ConversionService {

  /**
   * @return {import("angular").IPromise<unknown>}
   */
  registerConversionIfNeeded() {
    // @ts-ignore
    if (typeof create_awin_conversion !== 'undefined') {
      if (!!this.$cookies.get(CONVERSION_COOKIES_KEY)) {
        console.log("There's a conversion to report, but we already have.");
        // we've already reported a conversion recently.
        return null;
      }

      return this.$http.get('/api/v1/conversions/check')
        .then(response => {
          const conversion = response.data;
          if (!!conversion.subscriptionId) {
            console.log("Conversion: ", conversion.subscriptionId);
            create_awin_conversion(conversion);
            this.$cookies.put(
              CONVERSION_COOKIES_KEY,
              new Date().toUTCString(),
              {
                expires: this.$moment(new Date()).add(2, 'days').toDate(),
                secure: true,
                samesite: "strict",
              },
            )
          }
        });
    }

    return null;
  }

  /**
   * @private
   * @type {ng.IHttpService}
   */
  $http;

  /**
   * @private
   * @type {ng.IWindowService}
   */
  $window;

  /**
   * @private
   * @type {import('angular').cookies.ICookiesService}
   */
  $cookies;

  /**
   * @private
   * @type {typeof import("moment")}
   */
  $moment;

  constructor($http, $window, $cookies, $moment) {
    this.$http = $http;
    this.$window = $window;
    this.$cookies = $cookies;
    this.$moment = $moment;
  }
}

export default ['$http', '$window', '$cookies', 'moment', ConversionService];
